export default "__VITE_ASSET__BdAT7k4b__"